import { render, staticRenderFns } from "./CollectiveRequests.vue?vue&type=template&id=168360e8&scoped=true&"
import script from "./CollectiveRequests.vue?vue&type=script&lang=js&"
export * from "./CollectiveRequests.vue?vue&type=script&lang=js&"
import style0 from "./CollectiveRequests.vue?vue&type=style&index=0&id=168360e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168360e8",
  null
  
)

export default component.exports